



















































































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import ProductsMixin from "@/mixins/http/ProductsMixin";
import ConfirmModal from "@/components/ConfirmModal.vue";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import VContentLoading from "@/components/VContentLoading.vue";
import { NoCache, RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { Product, Family } from "../../models";
import Search from "@/components/VEntrySearch.vue";
import Filters from "@/components/Product/Filters.vue";
import { showToast } from "../../utils/RailsRoutes";
import { currentUserStore } from "@/store/typed";

@Component({
  components: {
    Search,
    Paginator,
    DataTable,
    Filters,
    ConfirmModal,
    VContentLoading,
  },
})
export default class ProductList extends Mixins(ProductsMixin) {
  @Prop({ required: true })
  readonly family!: Family;

  @Prop({ default: true })
  readonly editable!: boolean;

  @Prop({ default: "USD" })
  readonly currency!: boolean;

  private showFilters = false;

  page = 1;
  search = null;

  private readonly confirmModalName = "confirm_deletion_modal";

  private items: Product[] = [];
  private filter = null;

  static readonly getProductsTag = "get_products_tag";
  @RegisterHttp(ProductList.getProductsTag) getProductsRequest: RequestData;

  onCancel(name: string) {
    this.showModal(name, false);
  }

  destroyTag(value) {
    return `destroy_product_${value.id}_tag`;
  }

  get meta() {
    return this.getProductsRequest?.meta;
  }

  onReset() {
    this.page = 1;
    this.filter = null;
    this.loadProducts();
  }

  onAddClicked() {
    this.$router.push({
      name: "product_create",
      query: { familyId: this.family.id },
    });
  }

  applyFilters(value) {
    this.page = 1;
    this.filter = value.filter;

    if (!this.filter) {
      this.filter = {};
    }
    this.filter.family = this.family.id;
    this.loadProducts();
  }

  get hasFilters() {
    return this.filter || this.search;
  }

  onSearchCanceled() {
    this.page = 1;
    this.search = null;
    this.loadProducts();
  }

  onSearched(items) {
    this.page = 1;
    this.items = items.items;
  }

  get hasItems() {
    return this.items?.length > 0;
  }

  get loading() {
    return this.getProductsRequest?.loading;
  }
  onPageChange(page) {
    this.page = page;
    this.loadProducts();
  }

  @NoCache
  get payload() {
    let data: any = {
      page: this.page,
      filter: {
        family: this.family.id,
        ...this.filter,
      },
    };

    if (currentUserStore.currentUser.belongsToCompany) {
      data.companyId = currentUserStore.company.slug;
    }

    if (this.search) {
      data.filter.term = this.search;
    }

    return data;
  }

  async searchProducts(name: string) {
    if (name.trim().length > 0) {
      this.search = name;
      const products = await this.getProducts(
        this.payload,
        ProductList.getProductsTag
      );
      return products;
    }
  }

  onAdded(product) {
    this.items.unshift(product);
  }

  onEdited(value) {
    const index = this.items.findIndex((o) => o.id === value.id);
    Vue.set(this.items, index, value);
  }

  onEditClicked(product: Product) {
    this.$router.push({ name: "product_edit", params: { id: product.id } });
  }

  showModal(name: string, show: boolean) {
    const modal = this.$refs[name] as any;
    show ? modal?.show() : modal?.hide();
  }

  async onDestroyClicked(value) {
    const confirmed = await (this.$refs[this.confirmModalName] as any).confirm(
      "Are you sure you want to delete this product? All saved data will be lost."
    );
    const tag = this.destroyTag(value);
    if (confirmed) {
      this.destroyProduct(value.id, tag).then(
        (resp) => {
          this.items = this.items.filter((o) => o.id !== resp.id);
          showToast("Product deleted successfully!");
        },
        (err) => {}
      );
    }
  }

  showConfrmationModal() {
    const modal = this.$refs[this.confirmModalName] as any;
    modal.confirm(
      "Are you sure you want to delete this product? All saved data will be lost."
    );
  }

  goToSettings() {
    this.$router.push({ name: "catalogue_settings" });
  }

  loadProducts() {
    this.getProducts(this.payload, ProductList.getProductsTag).then((resp) => {
      this.items = resp;
    });
  }

  get columns() {
    let columns = [];
    columns.push({ name: "code", label: "Code" });
    if (this.$mq !== "sm" && this.$mq !== "md") {
      columns.push({ name: "typology", label: "Description" });
      columns.push({ name: "measurementUnit", label: "Measurement Unit" });
    }
    columns.push({ name: "price", label: "Price" });
    if (this.editable) {
      columns.push({ name: "actions", label: "Actions" });
    }
    return columns;
  }
}
